import { useRouterState } from '@tanstack/react-router';

/**
 * Returns `true` when the current pathname starts with the given path prefix.
 *
 * @param path - The path prefix to match against (e.g. `'/tenants'`).
 */
export function useActivePath(path: string): boolean {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return path === '/' ? pathname === '/' : pathname.startsWith(path);
}
